(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('supplierPanel.companyServants', {
                parent: 'supplierPanel',
                url: '/company-servants',
                data: {
                    authorities: ['ROLE_SERVANT_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.servantInfo'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-servants/company-servants.html',
                        controller: 'CompanyServantsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel.companyServants.new', {
                parent: 'supplierPanel',
                url: '/companyServants/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-servants/company-servants-dialog.html',
                        controller: 'CompanyServantsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            title: null,
                            level: null,
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel.companyServants.edit', {
                parent: 'supplierPanel',
                url: '/companyServants/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-servants/company-servants-dialog.html',
                        controller: 'CompanyServantsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['Servant', '$stateParams', function (Servant, $stateParams) {
                        return Servant.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('supplierPanel.companyServants.delete', {
                parent: 'supplierPanel.companyServants',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-servants/company-servants-delete-dialog.html',
                        controller: 'CompanyServantsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Servant', function (Servant) {
                                return Servant.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel.companyServants', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
